import React, { useState } from "react";
import {
  TouchableOpacity,
  View,
  StyleSheet,
  Pressable,
  Image,
} from "react-native";
import Text from "@components/CustomText";
import { useNavigation } from "@react-navigation/native";
import ChevronRight from "@assets/svg/ChevronRight";
import { format } from "date-fns";
import t from "@constants/localization";
import RatingView from "./RatingView";
import CancelOrReopenDialog from "./CancelOrReopenDialog";
import reopenSupportTicket from "../utils/reopenSupportTicket";
import EditButton from "../../../assets/svg/EditButton";
import EditUpArrow from "../../../assets/svg/EditUpArrow";
import colors from "@constants/color";

const PATH = "screens/SupportTree/SupportTickets/TicketCard";

const colorMap = {
  कैंसिल्ड: "#C41A16",
  साल्व्ड: "#55CD1D",
  प्रोसेसिंग: "#F25700",
};

const TicketCard = ({
  ticket,
  handleReloadList = () => {},
  onCancelTicket = () => {},
  fetching = false,
}) => {
  const {
    subject,
    statusText,
    status,
    updated_at,
    id,
    ticket_id,
    created_at,
    cancelled_at,
    resolved_at,
    app_status,
    rating,
    rating_date,
    cf_issue_level_1,
    edit_ticket,
  } = ticket;

  const navigation = useNavigation();
  const [showReopenModal, setShowReopenModal] = React.useState(false);
  const [isEditing, setIsEditing] = useState(false);
  return (
    <TouchableOpacity
      style={style.outerView}
      onPress={() => {
        navigation.navigate("SupportTicket", { ticketId: ticket_id });
      }}
    >
      <CancelOrReopenDialog
        visible={showReopenModal}
        title={t(`${PATH}/cancelTicket`)}
        message={t(`${PATH}/cnfmTicketCancellation`, { ticketId: ticket_id })}
        buttons={[
          {
            text: t(`${PATH}/no`),
            onPress: () =>
              reopenSupportTicket(
                "cancel",
                ticket_id,
                cf_issue_level_1,
              )(() => {
                setShowReopenModal(false);
                handleReloadList();
              }),
            style: "cancel",
          },
          {
            text: t(`${PATH}/yes`),
            onPress: () =>
              reopenSupportTicket(
                "okay",
                ticket_id,
                cf_issue_level_1,
              )(() => {
                setShowReopenModal(false);
                handleReloadList();
              }),
            style: "okay",
          },
        ]}
      />
      <View style={style.wrapper}>
        <View style={style.wrapperView}>
          <Text variant="body_text_4" style={style.subjectText}>
            {subject}
          </Text>
          <View style={{ flexDirection: "row" }}>
            <ChevronRight pathFill="#E40046" width={8} height={20} />
          </View>
        </View>
        <Text
          variant="body_text_3"
          style={{ color: "rgba(0,0,0,0.56)", marginBottom: 10 }}
        >
          {t(`${PATH}/ticketNo`)} : {ticket_id} •{" "}
          {format(new Date(created_at), "dd MMM yyyy, hh:mm aaaa")}
        </Text>
        <Text variant="body_text_3" style={{ color: "rgba(0,0,0,0.56)" }}>
          {t(`${PATH}/status`)} :{" "}
          <Text variant="body_text_4" style={{ color: colorMap[app_status] }}>
            {app_status}{" "}
          </Text>
          {(cancelled_at && (
            <Text variant="body_text_3" s>
              {" "}
              • {format(new Date(cancelled_at), "do MMM yyyy, hh:mm aaaa")}
            </Text>
          )) ||
            (resolved_at && (
              <Text variant="body_text_3">
                {" "}
                •{"  "}
                {format(new Date(resolved_at), "do MMM yyyy, hh:mm aaaa")}
              </Text>
            ))}
        </Text>
      </View>
      <View style={style.ctaWrapper}>
        {edit_ticket && (
          <EditRating setIsEditing={setIsEditing} isEditing={isEditing} />
        )}

        {rating && resolved_at && rating_date > resolved_at && (
          <GivenRatingView rating={rating} />
        )}
      </View>
      {resolved_at &&
        !cancelled_at &&
        (!rating || rating_date < resolved_at) && (
          <RatingView
            ticket_id={ticket_id}
            issueLevel1={cf_issue_level_1}
            handleReloadList={handleReloadList}
            showReopenModalHandler={() => setShowReopenModal(true)}
          />
        )}

      {isEditing && (
        <RatingView
          ticket_id={ticket_id}
          issueLevel1={cf_issue_level_1}
          handleReloadList={handleReloadList}
          showReopenModalHandler={() => setShowReopenModal(true)}
        />
      )}
    </TouchableOpacity>
  );
};

const style = StyleSheet.create({
  wrapper: {
    backgroundColor: "#fefefe",
    padding: 15,
    marginTop: 0,
  },
  subjectText: {
    color: "#3e3e3e",
  },
  ctaWrapper: {
    paddingHorizontal: 25,
    flexDirection: "row",
    justifyContent: "space-between",
    backgroundColor: "#fefefe",
    width: "100%",
  },
  editBtnContainer: {
    justifyContent: "center",
    alignItems: "center",
    paddingLeft: 30,
  },
  outerView: { marginBottom: 8, elevation: 2, backgroundColor: colors.white },
  wrapperView: {
    flexDirection: "row",
    justifyContent: "space-between",
    flexWrap: "wrap",
    flex: 1,
    marginBottom: 10,
  },
  ticketNumberWithDate: {
    color: colors.greyTone1,
    marginBottom: 10,
    marginLeft: -1,
  },
  line: {
    backgroundColor: colors.borderBox,
    height: 1,
    width: "90%",
    alignSelf: "center",
  },
});

export default TicketCard;

const EditRating = (props) => {
  return (
    <Pressable
      onPress={() => props.setIsEditing(!props.isEditing)}
      style={style.editBtnContainer}
    >
      {!props.isEditing ? <EditButton /> : <EditUpArrow />}
    </Pressable>
  );
};

const GivenRatingView = ({ rating }) => {
  const renderRatingImage = (r) => {
    const rating = Number(r);
    switch (rating) {
      case 1:
        return (
          <>
            <Image
              source={{
                uri: "https://pub-storage-svc.citymall.live/1628741486281Terrible_select.png",
              }}
              style={{ width: 32, height: 32, marginLeft: 10 }}
            />
          </>
        );
      case 2:
        return (
          <>
            <Image
              source={{
                uri: "https://pub-storage-svc.citymall.live/1628741426943Bad_select.png",
              }}
              style={{ width: 32, height: 32, marginLeft: 10 }}
            />
          </>
        );
      case 3:
        return (
          <>
            <Image
              source={{
                uri: "https://pub-storage-svc.citymall.live/1628741558644Okay_select.png",
              }}
              style={{ width: 32, height: 32, marginLeft: 10 }}
            />
          </>
        );
      case 4:
        return (
          <>
            <Image
              source={{
                uri: "https://pub-storage-svc.citymall.live/1628741616339Good_select.png",
              }}
              style={{ width: 32, height: 32, marginLeft: 10 }}
            />
          </>
        );
      case 5:
        return (
          <>
            <Image
              source={{
                uri: "https://pub-storage-svc.citymall.live/1628741680787Great_select.png",
              }}
              style={{ width: 32, height: 32, marginLeft: 10 }}
            />
          </>
        );
    }
  };
  return (
    <View style={{ flexDirection: "row" }}>
      <View style={{ paddingTop: 0 }}>
        <Text style={{ color: "rgba(0, 0, 0, 0.56)" }}>
          {t(`${PATH}/yourGiven`)}
        </Text>
        <Text style={{ color: "rgba(0, 0, 0, 0.56)" }}>
          {" "}
          {t(`${PATH}/rating`)}
        </Text>
      </View>
      {renderRatingImage(rating)}
    </View>
  );
};
